import { create } from 'zustand';

// P12 (D30) — per-FIELD remote editing presence: which input a peer currently has focused/active,
// and in whose color. The field-level counterpart of the element editing badge (PresenceLayer draws
// that as a canvas overlay; a field ring lives INSIDE the peer's open form, which the canvas can't
// reach — so the form reads this store instead).
//
// Lives in Common (not the Diagrams feature) so shared form primitives can READ it without a
// feature dependency; the Diagrams PresenceLayer is its sole WRITER (feature → Common is fine).
// Mirrors useEdgeRemoteSelectionStore: PresenceLayer publishes the full
// `"<targetType>:<targetId>:<fieldKey>" -> {color,name,active}` map via `setFieldPresence`; each input
// is a reader via `useFieldPresence(...)`, so only the input whose entry changed re-renders.
//
// Advisory Layer-2 presence: never persisted, never disables an input, never triggers recompute (D10).
export const fieldPresenceKey = (targetType, targetId, fieldKey) =>
  `${targetType}:${targetId}:${fieldKey}`;

export const useFieldPresenceStore = create((set) => ({
  byKey: {},
  setFieldPresence: (byKey) => set({ byKey: byKey || {} }),
}));

// Per-field selector → { color, name, active } for the peer editing this field, or null when none.
// Returns a stable null (not a fresh object) so an idle input never re-renders on unrelated deltas.
export const useFieldPresence = (targetType, targetId, fieldKey) =>
  useFieldPresenceStore((s) =>
    targetType && targetId && fieldKey
      ? (s.byKey[fieldPresenceKey(targetType, targetId, fieldKey)] ?? null)
      : null,
  );
